<template>
  <div>
    <b-card class="mt-4">
      <div v-show="!isLoaded">
        <Loading ref="loadingSpinner"></Loading>
      </div>
      <div v-if="isLoaded">
        <b-overlay :show="busy" rounded="sm">
          <div class="row pb-3">
            <div class="col">
              <h3>Samochody dostawcze</h3>
            </div>
            <div class="col">
              <button type="button" class="btn btn-primary float-right" @click="AddVehicle">
                <i class="fas fa-plus-circle fa-1x"></i> Dodaj samochód
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-1 font-weight-bold">ID</div>
            <div class="col-md-8 font-weight-bold">Nazwa</div>
            <div class="col-md-3 font-weight-bold">Akcje</div>
          </div>
          <div class="row p-1" v-for="vehicle in vehicles" :key="vehicle.id">
            <div class="col-md-1">#{{ vehicle.id }}</div>
            <div class="col-md-8">
              <input type="text" :disabled="!vehicle.isEdit" class="form-control" v-model="vehicle.name" />
            </div>
            <div class="col-md-3 div-icons-area">
              <span @click="SaveData(vehicle)" v-if="vehicle.isEdit"><i class="fas fa-check fa-lg color-green"></i></span>
              <span @click="ChangeEditStatus(vehicle, false)" v-if="vehicle.isEdit">
                <i class="fas fa-times fa-lg color-red"></i>
              </span>
              <span v-if="!vehicle.isEdit" @click="ChangeEditStatus(vehicle, true)" v-b-tooltip.hover
                title="Zmień numer rejestracyjny">
                <i class="fas fa-edit fa-lg"></i></span>
              <span v-b-tooltip.hover title="Usuń samochód dostawczy" v-if="!vehicle.isEdit"
                @click="RemoveVehicle(vehicle)">
                <i class="fas fa-trash fa-lg"></i>
              </span>
            </div>
          </div>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import Loading from "../../Common/Loading";

export default {
  name: "VehicleAdministration",
  components: { Loading },
  mixins: [urlConfig, toastr],
  mounted() {
    this.GetVehicles();
  },
  data() {
    return {
      busy: false,
      vehicles: [],
      isLoaded: false,
    };
  },
  methods: {
    GetVehicles() {
      var url = this.url.serverUrl + this.url.Vechicles.GetVechicles;
      var that = this;
      axios
        .get(url)
        .then(function (response) {
          response.data.forEach(function (entry) {
            entry.isEdit = false;
          });
          that.vehicles = response.data;
          that.isLoaded = true;
        })
        .catch(function (e) {
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
          that.isLoaded = false;
        });
    },
    AddVehicle() {
      this.vehicles.unshift({ isEdit: true });
    },

    SaveData(item) {
      if (item.id) {
        this.UpdateVehicle(item);
      } else {
        this.SaveNewVehicle(item);
      }
    },

    SaveNewVehicle(item) {
      var url = this.url.serverUrl + this.url.Vechicles.AddDeliveryVehicle;
      var that = this;
      this.busy = true;
      axios
        .post(url, { name: item.name })
        .then(function (response) {
          item.isEdit = false;
          item.id = response.data.id;
          that.DisplaySuccess(
            "Sukces!",
            "Nowy samochód o rejestracji: '" + item.name + "' został dodany"
          );
          that.busy = false;
        })
        .catch(function (e) {
          that.busy = false;
          console.log(e);
        });
    },

    ChangeEditStatus(item, status) {
      if (status == true) {
        item.oldName = item.name;
      } else {
        item.name = item.oldName;
        item.oldName = undefined;
        if (!item.id) {
          this.vehicles = this.vehicles.filter((x) => x.id != undefined);
        }
      }

      item.isEdit = status;
    },
    UpdateVehicle(item) {
      var url = this.url.serverUrl + this.url.Vechicles.EditVehicle;
      var that = this;
      this.busy = true;
      axios
        .post(url, { name: item.name, id: item.id })
        .then(function (response) {
          item.isEdit = false;
          item.id = response.data;
          that.DisplaySuccess(
            "Sukces!",
            "Numer rejestracyjny został zmieniony"
          );
          that.busy = false;
        })
        .catch(function (e) {
          that.busy = false;
          console.log(e);
        });
    },
    RemoveVehicle(item) {
      if (confirm("Czy napewno chcesz usunać samochód: " + item.name)) {
        var that = this;
        var url = this.url.serverUrl + this.url.Vechicles.RemoveVehicle;
        this.busy = true;
        axios
          .post(url, { name: item.name, id: item.id })
          .then(function () {
            that.vehicles = that.vehicles.filter((x) => x.id != item.id);
            that.busy = false;
          })
          .catch(function (e) {
            console.log(e);
            that.busy = false;
          });
      }
    },
  },
};
</script>